import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFacebookRound = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	width: "24px",
	height: "24px",
	viewBox: "0 0 24 24",
	style: { enableBackground: "new 0 0 24 24" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		fill: "#FFF",
		d: "M12,0C5.3725586,0,0,5.3725586,0,12s5.3725586,12,12,12s12-5.3725586,12-12S18.6274414,0,12,0z M14.5249634,12.3076782         h-1.6512451c0,2.6392212,0,5.8892212,0,5.8892212h-2.4484863c0,0,0-3.2174683,0-5.8892212H9.2615356v-2.0810547h1.1636963         V8.8809204c0-0.9638672,0.4581909-2.4708252,2.4697266-2.4708252l1.8133545,0.0076294V8.437439c0,0-1.1022949,0-1.3163452,0         c-0.2142944,0-0.5182495,0.1066895-0.5182495,0.5664673v1.2227173h1.8647461L14.5249634,12.3076782z"
	}) })
});
export default SvgFacebookRound;
